import {Injectable} from 'ng-metadata/core';

@Injectable()
export class MoreLikeThisItemService {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/moreLikeThis/moreLikeThisItem/moreLikeThisItem.service.ts